import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/:unitId/adminPortal/formAndFieldSettings.
//
// Single route — list page is the index. The form builder opens inside a
// fullscreen UIModal hosted by the list page (no separate route, no URL
// param). Trade-off: deep-linking to a specific form is no longer
// supported. If that becomes a requirement, add a `:formId` child route
// here and have the list page read it on mount to auto-open the modal.
export default store => ({
  path: "formAndFieldSettings",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/FormAndFieldSettingsListPage"
    ).then(m => m.default)
  ),
});
